import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

export default function NavLinkDelay(props) {
  const navigate = useNavigate();

  const to = props.to;
  const classes = props.className;
  const children = props.children;

  const [isClickable, setClickable] = useState(false);

  // Really over complicated, step through it as best as you can
  function delayAndGo(e) {
    e.preventDefault(); //prevent default

    // check if button click action is running
    if (isClickable) {
      return false;
    }

    // if action isnt already running set
    setClickable(true);

    toggleRootClassStyling();

    // Allows for css animation to take place before directing to route
    setTimeout(function () {
      // second timer prevents page flash due to dom render
      setTimeout(function () {
        navigate(to);
        // Close Mobile Menu
        document.querySelector('.menu').classList.remove('mobile-menu--open');
      }, 200);

      toggleRootClassStyling();
    }, 2000);

    // Releases button from being disabled after render complete
    setTimeout(function () {
      setClickable(false);
    }, 2200);
  }

  function toggleRootClassStyling() {
    const element = document.querySelector('#root');

    element.classList.toggle('fadePageOut');
  }

  return (
    <NavLink to={to} className={classes} onClick={delayAndGo}>
      {children}
    </NavLink>
  );
}
